<div class="unsubscribe-container">
  <div class="card">
    <div class="card-header">
      <h1>{{ 'unsubscribtion.title' | translate }}</h1>
    </div>

    <div class="card-body">
      <div class="description">
        <p>{{ 'unsubscribtion.description' | translate }}</p>
        <p class="warning">
          {{ 'unsubscribtion.warning' | translate }}
        </p>
      </div>

      <div class="actions">
        <button class="btn btn-danger" (click)="onUnsubscribe()">
          {{ 'unsubscribtion.actions.confirm' | translate }}
        </button>

        <button class="btn btn-secondary" (click)="goHome()">
          {{ 'unsubscribtion.actions.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
